import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  isTrailerDownloadable,
  makeTrailerDownloadable,
} from "../../services/movieServices";

const TrailerDownloadableButton = ({ movie, label }) => {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [downloaded, setDownloaded] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAction = async () => {
    setLoader(true);
    try {
      const res = await makeTrailerDownloadable(movie._id);
      if (res["status"] == "Downloaded") {
        setDownloaded(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpen(false);
      setLoader(false);
      //window.location.reload();
    }
  };

  useEffect(() => {
    if (!movie?._id) return;

    const checkDownloadable = async () => {
      try {
        const res = await isTrailerDownloadable(movie._id);
        setDownloaded(res.data.downloaded);
      } catch (err) {
        console.error(err);
        setDownloaded(false);
      }
    };

    checkDownloadable();
  }, [movie._id]);

  return (
    <React.Fragment>
      <label
        className="label label-primary add-to-cart"
        style={{ cursor: "pointer" }}
        onClick={() => !downloaded && setOpen(true)}
      >
        <span
          className={`badge ${
            downloaded ? "bg-secondary" : "bg-success"
          } btnLabel`}
        >
          {downloaded === null
            ? "Checking..."
            : downloaded
            ? "Already Downloadable"
            : label}
        </span>
      </label>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"African Movies Admin Dashboard."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you wish to make this movie trailer downloadable ? This action is
            not reversible. Are you sure you want to proceed ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!loader && (
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
          )}
          {loader ? (
            <Button color="primary" disabled>
              Please wait...
            </Button>
          ) : (
            <Button onClick={handleAction} color="primary" autoFocus>
              Proceed
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default TrailerDownloadableButton;
